<template>
  <Modal :value="open" :onClose="close" :close="false" title="Menu Fiscal - AWS">
    <b-row class="form-group">
      <b-col sm="12">
        <Select
          label="Selecione uma das opções"
          labelBold
          id="action"
          placeholder="Nenhum"
          v-model="action"
          :options="actionOptions"
        />
      </b-col>
    </b-row>
    <template v-if="action === 0">
      <b-row class="form-group text-center">
        <b-col sm="12">
          <br />
          <Label bold>Identificação da empresa desenvolvedora</Label>
          <hr />
          <Label>CNPJ: 03.916.076/0004-00</Label><br />
          <Label>Razão Social: ZUCCHETTI SOFTWARE E SISTEMAS LTDA</Label>
          <Label>
            Endereço: Rodovia, Sc 401, 4150, Sala 01 e 02, SACO GRANDE II FLORIANOPOLIS - SC
          </Label>
          <Label>Telefone: (49) 3442-0122</Label><br />
          <Label>Contato: Wagner Aragones Muller</Label>
          <hr />
          <Label>Identificação da PAF NFC-e</Label><br />
          <Label>Nome Comercial: Clipp360</Label><br />
          <Label>Versão: 1.0.0</Label>
        </b-col>
      </b-row>
    </template>
    <template v-if="action === 1">
      <b-row class="form-group">
        <b-col sm="6">
          <Label bold>Selecione um Período</Label>
          <InputDate
            id="fromPeriod"
            placeholder="Selecione um período"
            v-model="date"
            format="DD/MM"
          />
        </b-col>
        <b-col sm="6">
          <Select
            label="Registros do Estoque - E2"
            labelBold
            id="registerType"
            placeholder="Tipo do Registro"
            v-model="registerType"
            :options="registerTypeOptions"
          />
        </b-col>
      </b-row>
      <template v-if="registerType == parcialStock">
        <b-row class="form-group">
          <b-col sm="12">
            <SelectSearch
              label="Selecione um Produto"
              labelSearch="description"
              placeholder="Informe o código, descrição ou referência do produto"
              v-model="product"
              ref="searchProduct"
              inputClass="busca-cliente"
              :options="products"
              :search="onSearch"
              :change="onChange"
            />
          </b-col>
        </b-row>
        <b-row class="form-group" v-if="productsSelect.length > 0">
          <b-col class="busca">
            <table class="table">
              <thead>
                <tr>
                  <th>Produtos</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(el, key) in productsSelect" :key="'product' + key">
                  <td>{{ el.description }}</td>
                  <td align="right">
                    <a href="javascript:" @click="removeProduct" class="remove-pgto">
                      <Close />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-if="action === 2">
      <b-row class="form-group">
        <b-col sm="6">
          <Label bold>Selecione um Mês</Label>
          <InputDate
            id="fromMonth"
            placeholder="Selecione um Mês"
            v-model="month"
            :range="false"
            format="MM"
            type="month"
          />
        </b-col>
        <b-col sm="6">
          <Label bold>Selecione um Ano</Label>
          <InputDate
            id="fromYear"
            placeholder="Selecione um Ano"
            v-model="year"
            :range="false"
            format="YYYY"
            type="year"
          />
        </b-col>
      </b-row>
      <b-row class="form-group">
        <b-col>
          <Input
            ref="cpfcnpj"
            label="CPF/CNPJ"
            id="cpfcnpj"
            :mask="['UUU.UUU.UUU-UU', 'UU.UUU.UUU/UUUU-UU']"
            labelBold
            v-model="identification"
          />
        </b-col>
      </b-row>
    </template>
    <template v-if="action === 3">
      <b-row class="form-group">
        <b-col sm="6">
          <Label bold>Selecione um Período</Label>
          <InputDate id="fromPeriodDavs" placeholder="Selecione um período" v-model="date" />
        </b-col>
      </b-row>
    </template>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()" v-if="action">Gerar</Button>
      <ModalLoading
        :title="modalLoadingTitle"
        :subtitle="modalLoadingSubtitle"
        :information="modalLoadingInformation"
        :open="modalLoading"
        :onClose="closeModalLoading"
      />
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash';
import { Modal } from '@/components';
import { Button, Label, Select, SelectSearch, Input, InputDate } from '@/components/Form';
import Close from 'vue-material-design-icons/Close';
import PafMixin from '@/modules/Fiscal/mixins/PAFMixin';
import ProductMixin from '@/modules/Fiscal/mixins/ProductMixin';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import ProfileMixin from '@/modules/Application/mixins/ProfileMixin';
import { connectSocket } from '@/configurations/webSocket';
import { ModalLoading } from '@/components/ModalLoading';

export default {
  name: 'ModalRegisterCardManager',
  mixins: [PafMixin, ProductMixin, FormatMixin, ProfileMixin],
  components: {
    Modal,
    Button,
    Label,
    Select,
    SelectSearch,
    Input,
    InputDate,
    Close,
    ModalLoading,
  },
  data() {
    return {
      parcialStock: 2,
      totalStock: 1,
      action: null,
      actionOptions: [
        {
          value: 0,
          text: 'Identificação do PAF NFC-e',
        },
        {
          value: 1,
          text: 'Gerar arquivo do PAF NFC-e',
        },
        {
          value: 2,
          text: 'Vendas identificadas pelo CPF/CNPJ',
        },
        {
          value: 3,
          text: 'Controle dos DAVs',
        },
      ],
      date: new Date(),
      month: new Date(),
      year: new Date(),
      identification: null,
      registerType: null,
      registerTypeOptions: [],
      product: {},
      productsSelect: [],
      modalLoading: false,
      modalLoadingTitle: 'Arquivos PAF',
      modalLoadingSubtitle: 'Relatório em Processamento',
      modalLoadingInformation: `Isto pode demorar um pouco dependendo da quantidade de dados do relatório.
      Se preferir, você pode fechar esta janela, e ser notificado quando o relatório estiver disponível.`,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  methods: {
    parsePafInventoryTypes() {
      if (!this.pafInventoryTypes) {
        return false;
      }

      this.registerTypeOptions = this.pafInventoryTypes.map(({ id, description }) => ({
        value: id,
        text: description,
      }));

      this.registerType = this.totalStock;

      return true;
    },
    async getSearchProducts(search = null) {
      const params = {
        active: true,
        maxResults: 10,
        isPDV: true,
      };

      if (search) {
        params.search = search;
      }

      await this.getProducts(params);
    },
    onChange(selected) {
      this.productsSelect.push(selected);
    },
    onSearch(search, loading) {
      this.debounce(loading, search, this.getSearchProducts);
    },
    debounce: _.debounce(async (loading, search, callback) => {
      if (!search) {
        return loading(false);
      }

      loading(true);
      await callback(search);

      return loading(false);
    }, 350),
    removeProduct(indice) {
      this.productsSelect.splice(indice, 1);
    },
    openPAFNFCe() {
      const { date, registerType, productsSelect } = this;

      if (!date) {
        return this.$alert.error('Informe um período!');
      }

      if (registerType === this.parcialStock && !this.productsSelect[0]) {
        return this.$alert.warning('Nenhum produto foi selecionado.');
      }

      const payload = {
        fromDate: this.$moment(date[0]).format('YYYY-MM-DD'),
        toDate: this.$moment(date[1]).format('YYYY-MM-DD'),
      };

      if (registerType === this.parcialStock) {
        payload.productsSelected = productsSelect;
      }

      this.generatePAFNFCe(payload);
      this.openModalLoading();
      return this.receiveResponseViaSocket();
    },
    openSalesPAFNFCeSC() {
      const { month, year, identification } = this;

      if (!month) {
        return this.$alert.error('Informe o mês!');
      }

      if (!year) {
        return this.$alert.error('Informe o ano!');
      }

      const payload = {
        month: this.$moment(month).format('MM'),
        year: this.$moment(year).format('YYYY'),
        identification: this.formatCpfCnpj(identification),
      };

      this.genarateSalesPAFNFCeSC(payload);
      this.openModalLoading();
      return this.receiveResponseViaSocket();
    },
    openTradesPAFNFCeSC() {
      const { date } = this;

      if (!date) {
        return this.$alert.error('Informe um período!');
      }

      const payload = {
        fromDate: this.$moment(date[0]).format('YYYY-MM-DD'),
        toDate: this.$moment(date[1]).format('YYYY-MM-DD'),
      };

      this.genarateTradesPAFNFCeSC(payload);
      this.openModalLoading();
      return this.receiveResponseViaSocket();
    },
    receiveResponseViaSocket() {
      const webSocket = connectSocket();

      if (window.isSocketIOConnected) return false;

      return webSocket.on('connect', () => {
        window.isSocketIOConnected = true;

        webSocket.on(`report_${this.userProfile.id}`, (data) => {
          const urls = Object.values(data);
          urls.forEach((url) => {
            window.open(url, '_blank');
          });

          webSocket.close();
          this.closeModalLoading();
          window.isSocketIOConnected = false;
        });

        webSocket.on('error', () => {
          this.$alert.error('Ocorreu um erro na geração dos arquivos PAF');
          webSocket.close();
          this.closeModalLoading();
          window.isSocketIOConnected = false;
        });
      });
    },
    openModalLoading() {
      this.modalLoading = true;
    },
    closeModalLoading() {
      this.modalLoading = false;
    },
    async save() {
      try {
        if (this.action === 1) {
          await this.openPAFNFCe();
        }

        if (this.action === 2) {
          await this.openSalesPAFNFCeSC();
        }

        if (this.action === 3) {
          await this.openTradesPAFNFCeSC();
        }

        return true;
      } catch ({ message }) {
        return this.$alert.error(message);
      }
    },
  },
  async mounted() {
    await this.getPAFInventoryType();
    this.parsePafInventoryTypes();
    await this.getProfile();
    await this.getSearchProducts();
  },
};
</script>
